// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","574":"component---src-pages-publications-tsx"}[chunkId] || chunkId) + "-" + {"245":"cc6ecf1b804ac87c80cd","453":"a9d6d07b8bdacd0e3159","454":"cdd41e2f512e138956c2","574":"57e97389d7c978144094"}[chunkId] + ".js";
};